// src/components/FixedContactButtons.jsx
import React from "react";
import { FaPhone, FaWhatsapp } from "react-icons/fa6";

export default function FixedContactButtons() {
  return (
    <div className="fixed bottom-4 right-4 flex flex-col gap-3 z-50">
      {/* Call Button */}
      <a
        href="tel:+918012003040"
        className="flex items-center gap-2 bg-red-600 text-white px-4 py-3 rounded-full shadow-lg hover:bg-red-700 transition"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaPhone size={20} />
        
      </a>

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/918012003040"
        className="flex items-center gap-2 bg-green-600 text-white px-4 py-3 rounded-full shadow-lg hover:bg-green-700 transition"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp size={24} />
        
      </a>
    </div>
  );
}